'use client';

import { c as _c } from "react/compiler-runtime";
import { Root as LabelPrimitiveRoot } from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';
import { cn } from '@/lib/utils';
const labelVariants = cva('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70');
type LabelProperties = ComponentPropsWithoutRef<typeof LabelPrimitiveRoot> & VariantProps<typeof labelVariants> & {
  ref?: Ref<ComponentRef<typeof LabelPrimitiveRoot>>;
};
const Label = t0 => {
  const $ = _c(10);
  let className;
  let properties;
  let ref;
  if ($[0] !== t0) {
    ({
      className,
      ref,
      ...properties
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = properties;
    $[3] = ref;
  } else {
    className = $[1];
    properties = $[2];
    ref = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn(labelVariants(), className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== properties || $[7] !== ref || $[8] !== t1) {
    t2 = <LabelPrimitiveRoot ref={ref} className={t1} {...properties} />;
    $[6] = properties;
    $[7] = ref;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export { Label };